import { render } from "./Cancelados.vue?vue&type=template&id=2b038fe4&scoped=true"
import script from "./Cancelados.vue?vue&type=script&lang=js"
export * from "./Cancelados.vue?vue&type=script&lang=js"

import "./Cancelados.vue?vue&type=style&index=0&id=2b038fe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b038fe4"]])

export default __exports__